"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ksys_app_template_1 = require("@kurtosys/ksys-app-template");

var ComponentBase_1 = require("./ComponentBase");

var ResponsiveComponentBase =
/** @class */
function (_super) {
  __extends(ResponsiveComponentBase, _super);

  function ResponsiveComponentBase() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Object.defineProperty(ResponsiveComponentBase.prototype, "breakpoints", {
    get: function get() {
      var _this = this;

      var _a = this.props.breakpoints,
          breakpointsFromProps = _a === void 0 ? [] : _a;
      var response = [];

      if (!breakpointsFromProps || breakpointsFromProps.length === 0) {
        response = [{
          size: 'xsmall',
          modifier: 'up',
          props: this.props
        }];
      } else {
        response = breakpointsFromProps.map(function (breakpointProps) {
          return ksys_app_template_1.utils.object.deepMergeObjects({
            props: _this.props
          }, breakpointProps);
        });
      }

      return response;
    },
    enumerable: true,
    configurable: true
  });

  ResponsiveComponentBase.prototype.getBreakpointComponentProps = function (breakpoint, breakpointIndex) {
    var _a;

    var size = breakpoint.size,
        modifier = breakpoint.modifier;
    var breakpointProps = (_a = {
      key: breakpointIndex
    }, _a[size] = true, _a[modifier] = true, _a);
    return breakpointProps;
  };

  return ResponsiveComponentBase;
}(ComponentBase_1.ComponentBase);

exports.ResponsiveComponentBase = ResponsiveComponentBase;